import FilterInput from "../../FilterInput";
import React from "react";
import {ComboBoxFilterType} from "../ComboBoxTypes";
import {FormWrapperLabel, FormWrapperMinimum} from "../../FormEntryWrapper/FormEntryWrapper";

const ComboBoxFilter = (props: ComboBoxFilterType) => {
    if(props.minimal) {
        return (
            <FormWrapperMinimum invalid={!props.isValid} isActive={props.isLoading}>
                <ComboBoxFilterInput
                    {...props}
                />
            </FormWrapperMinimum>
        )
    }

    return (
        <FormWrapperLabel label={props.label} invalid={!props.isValid} validationMessage={props.errorMessage} isActive={props.isLoading}>
            <ComboBoxFilterInput
                {...props}
            />
        </FormWrapperLabel>
    )
}

const ComboBoxFilterInput = (props: ComboBoxFilterType) => {
    return (
        <FilterInput
            placeholder={props.placeholder}
            active={props.isActive}
            filterValue={props.filterSelectValue}
            resetCallback={(e: any) => props.resetCallback(e)}
            blurCallback={(e: any, func: any) => props.blurCallback(e, func)}
            minimal={props.minimal}
            filterCallback={(e: any) => props.filterActionCallback(e)}
            filterNavigationCallback={(e: any) => props.filterNavigationCallback(e)}
            filterFocusCallback={(e: any, func: any) => props.filterFocusCallback(e, func)}
            inputRef={props.filterRef}
            isLoading={props.isLoading}
            hideArrow={props.hideArrow}
        />
    )
}

export default ComboBoxFilter
